module.exports = __webpack_public_path__ + "static/media/km-KH.52a88ebf.md";